import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';
import * as yup from 'yup';

/**
 * @param {number} contractNumber
 * @returns {Promise<Success | Failure>}
 */
export async function getMountings(contractNumber) {
  try {
    const validatedContractNumber =
      getMountingsSchema.validateSync(contractNumber);

    const { data } = await api.get(
      `/montagem-prato/listar/${validatedContractNumber}`,
    );

    if (!data || !Array.isArray(data)) throw new Error('invalid data');

    return new Success(data);
  } catch (error) {
    let errorMessage = '';

    if (error instanceof yup.ValidationError) {
      console.error(error.message);
      errorMessage = error.message;
    }

    console.error('[getMountings] ERROR: ', error);

    return new Failure(errorMessage);
  }
}

const getMountingsSchema = yup.number().required().nonNullable().min(1);
